import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import Typography from "@material-ui/core/Typography/Typography";
import {
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    InputAdornment,
    Link,
    TableFooter,
    TextField, Tooltip,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "../../../../../components/formInputs";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import IconButton from "@material-ui/core/IconButton";
import {
    AccountType,
    ActionItems as CurrentActionsItems,
    ClientDocumentType,
    DocApprovalStatus,
    GWT_GEN2_STRATEGY,
    GWTVersionEnum,
} from "../../../../../constants";
import { dateUtils } from "../../../../../utils";
import ViewDocument from "../modals/ViewDocument";
import * as Aws from "../../../../../actions/aws";
import { useActions } from "../../../../../actions";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination } from "../../../../../components/table";
import * as Clients from "../../../../../actions/client";
import * as ClientActions from "../../../../../actions/client";
import useQueryString from "../../../../../hooks/useQueryString";
import DocumentApprovalActions from "./DocumentApprovalActions";
import DocumentApprovalSnackBar from "./DocumentApprovalSnackBar";
import CoverLetterSnackBar from "./CoverLetterSnackBar";
import PublishOutlinedIcon from "@material-ui/icons/PublishOutlined";
import ConfirmUploadDialog from "../modals/ConfirmUploadDialog";
import RequestClientDocModal from "../modals/RequestClientDocModal";
import LoaderGif from "../../../../../styles/images/loader_nw.gif";
import UploadSpecificDocument from "../dialogs/UploadSpecificDocument";
import TableWrap from "../../../../../components/TableWrap/TableWrap";
import MuiAlert from "@material-ui/lab/Alert";
import { downloadDocument, getDocumentNameAndType } from "../../../../../utils/commonUtils";
import { CircularLoading, TableView } from "../../../../../components/Common";
import PaymentDocuments, { SupportingDocumentTable } from "./PaymentDocuments";
import RejectChangingRequest from "../../../../../components/clientServicing/admin/components/RejectChangingRequest";

import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import {getGWTDocuments} from "../../../../../actions/client";
import {tempEnrollmentDirectory} from "../../../Kids/util";
const useStyles = makeStyles({
    table: {
        minWidth: 767,
    },
    tableHead: {
        backgroundColor: "#EDF3F8",
    },
    pd10:{
        padding:10
    } ,
    mb20:{
        marginBottom:20
    },
    mt20:{
        marginTop:20
    }
});

export default function DocumentsTab(props: {
    role: number | undefined,
    clientDetail: any,
    getClientDetail: Function,
    ssnFlag: boolean,
    clientPolicyId: string
}) {
    const clientActions = useActions(Clients);
    const { role, clientDetail, getClientDetail, ssnFlag, clientPolicyId } = props;
    const clientPolicy = clientDetail && clientDetail.client && clientDetail.client.clientPolicies && clientDetail.client.clientPolicies.length > 0 && clientDetail.client.clientPolicies[0]; 
    const classes = useStyles();
    const [documentList, setDocumentList] = React.useState([]);
    const [gwtDocumentList, setGwtDocumentList] = React.useState([]);
    const [documentListCount, setDocumentListCount] = React.useState(0);
    const [uploadMoreDocs, setUploadMoreDocs] = React.useState(false);
    const [openDocument, setOpenDocument] = React.useState(false);
    const [documentUrl, setDocumentUrl] = React.useState("");
    const [fileType, setFileType] = React.useState("");
    const [refresh, setRefresh] = React.useState<any>("");
    const awsActions = useActions(Aws);
    const [page, setPage] = useQueryString("page", 0);
    const [rowsPerPage, setRowsPerPage] = useQueryString("rowsPerPage", 25);
    const [orderBy] = useQueryString("orderBy", "createdAt");
    const [order, setOrder] = useQueryString("order", "desc");
    const [search, setSearch] = useQueryString("search", "");
    const [allDocApproved, setAllDocApproved] = React.useState(false);
    const [confirmDialog, setConfirmDialog] = React.useState(false);
    const [singleDocDetail, setSingleDocDetail] = React.useState({});
    const [snackBar, setSnackBar] = React.useState<boolean>(false);
    const [requestDoc, setRequestDoc] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [approveAllDocs, setApproveAllDocs] = React.useState(false);
    const [coverLetterReq, setCoverLetterReq] = React.useState<boolean>(false);
    const [uploadCoverLetter, setUploadCoverLetter] = React.useState<boolean>(false);
    const [documentToView, setDocumentToView] = React.useState<object>({});
    const [uploadAdditionalTaxDocs, setUploadAdditionalTaxDocs] = React.useState<boolean>(false);
    let additionalTaxDoc = !!(clientPolicy && clientPolicy.additionalTaxDocReq === 1);
    const [additionalTaxDocReq, setAdditionalTaxDocReq] = React.useState<boolean>(additionalTaxDoc);
    let AdditionalTaxDocsButtonText:string = "This case requires additional tax documents.";
    const defaultDirectory = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id;
    const isGWTGen2 = (clientPolicy && clientPolicy.strategyId === GWT_GEN2_STRATEGY);
    const isGWTGenV2 = clientDetail && clientDetail.client && clientDetail.client.gwtVersion === GWTVersionEnum.Two;
    const isAdminOrAgent = (role === AccountType.Admin || role === AccountType.MasterAdmin) || role === AccountType.Agent;

    const downloadFile = (document) => {
        return (
                <React.Fragment>
                    {
                            (role === 1 || role === 2) && !document.gwtV2 &&
                            <DocumentApprovalActions document={document}
                                                     clientDetail={clientDetail}
                                                     getClientDocuments={getClientDocuments}
                                                     setLoading={setLoading}
                                                     setRefresh={setRefresh}
                            />


                    }
                    <Link className="colorBlue" onClick={async () => {
                        await downloadDocument(document, document.enrollmentId || defaultDirectory, awsActions, undefined, isGWTGenV2);
                    }}><GetAppOutlinedIcon /></Link>

                    {
                            (role === 1 || role === 2) && !document.gwtV2 &&
                            ((document.frontOrBack === "Front" && document.approvalStatusFront !== DocApprovalStatus.APPROVED.approvalStatus) ||
                                    (document.frontOrBack === "Back" && document.approvalStatusBack !== DocApprovalStatus.APPROVED.approvalStatus))
                            && document.documentType && document.documentType !== ClientDocumentType.ADMIN_PROPOSAL &&
                            <>
                                <Link className="colorBlue" onClick={() => {
                                    setConfirmDialog(true);
                                    setSingleDocDetail(document);
                                }}><PublishOutlinedIcon /></Link>
                            </>
                    }
                </React.Fragment>
        );
    };

    const gridProps = {
        headers: ["Name", "Doc Type", "File Type", "Date Modified", "Uploaded By", "Actions"],
        list: gwtDocumentList.map((document: any) => {
            return {
                name: (
                        <Link
                                className="backBtn" color="primary"
                                onClick={() => {
                                    handleDocument(document);
                                    setDocumentToView(document);
                                }}
                        > {document.name} </Link>
                ),
                docType: document.documentType,
                fileTYpe: document.fileType,
                dateModified: dateUtils.asDbDateFormat(document.updatedAt),
                uploadedBy: document.user && document.user.firstName + " " + document.user.lastName,
                action: (
                        downloadFile(document)
                ),
            };
        }),
    };

    if(clientPolicy && clientPolicy.currentlyEmployed && clientPolicy.currentlyEmployed.toLowerCase() === "other"){
        if(clientPolicy && clientPolicy.parentsAreIncomeEarner){  //WT
            AdditionalTaxDocsButtonText = `This case requires Wealth Transfer docs.`;
        } else {
            AdditionalTaxDocsButtonText = `This case requires Income Earner docs.`;
        }
    } else if(clientPolicy && clientPolicy.usingSpouseIncome == "1" ){
        AdditionalTaxDocsButtonText = `This case requires Spouse docs.`;
    }

    useEffect(() => {
        if (clientDetail && clientDetail.client && clientDetail.client.id) {
            setAdditionalTaxDocReq(clientPolicy && clientPolicy.additionalTaxDocReq === 1);
        }
    }, [clientDetail]);

    useEffect(() => {
        if (clientPolicy && clientPolicy.id) {
            getClientDocuments(clientPolicy.id).then(() => {
            });
            getGWTDocuments(clientDetail.client.userId).then(() => {
            });
        }
        if (clientPolicy && clientPolicy.strategyId) {
            getClientDocuments(clientPolicy.id, clientPolicy.strategyId).then(() => {
                // delibratly running in then of previous to ensure sequence
                const parentDetails = clientDetail && clientDetail.parentUser;
                if (clientPolicy && isGWTGenV2 && parentDetails && parentDetails.clientPolicyId && isAdminOrAgent) {
                    // run again for gwtInvite type documents
                    getGWTInviteTypeClientDocuments(parentDetails.clientPolicyId).then();
                }
            });
        }
    }, [clientPolicy && clientPolicy.id, clientPolicy && clientPolicy.strategyId, page, rowsPerPage, order, orderBy, search, refresh]);

    useEffect(() => {
        if (clientPolicy && clientPolicy.clientId) {
            setCoverLetterReq(!!clientPolicy.coverLetterReq);
        }
    }, [clientPolicy && clientPolicy.clientId]);

    const getGWTInviteTypeClientDocuments = async (parentClientPolicyId: string) => {
        let list: any = [...gwtDocumentList];
        if (isGWTGenV2) {
            const gwtInviteDocs: any = await clientActions.getClientDocuments(parentClientPolicyId, {gwtInviteType: true} as any);
            gwtInviteDocs && gwtInviteDocs.forEach((doc: any) => {
                let documentName: string = doc.name;
                if (doc.path) {
                    doc.name = documentName + (doc.backPath ? " Front" : "");
                    let path = doc.path.split(".");
                    doc.fileType = path[path.length - 1].toUpperCase();
                    doc.frontOrBack = "Front";
                    list.push({ ...doc, documentName: documentName, gwtV2: isGWTGenV2 });
                }
                if (doc.backPath) {
                    doc.name = documentName + (doc.backPath ? " Back" : "");
                    let path = doc.path.split(".");
                    doc.fileType = path[path.length - 1].toUpperCase();
                    doc.frontOrBack = "Back";
                    list.push({ ...doc, path: "", documentName: documentName, gwtV2: isGWTGenV2 });
                }
            });
            setGwtDocumentList(list);
        }
    };

    const getClientDocuments = async (clientPolicyId: string, strategyId?: number) => {
        const isGWTGen2 = (strategyId === GWT_GEN2_STRATEGY);
        let queryObj: any = { page, rowsPerPage, search: search, sortBy: orderBy, order};

        if(isGWTGen2){
            let gwtObj: any = { gwt: true};
            queryObj = { ...queryObj, ...gwtObj };
        }
        const clientDetail = await clientActions.getClientDocuments(clientPolicyId, queryObj);
        let list: any = [];
        if (clientDetail && clientDetail.rows && clientDetail.rows.length > 0) {
            setSnackBar(true);
            if(!isGWTGen2){
                setDocumentListCount(clientDetail.count);
            }
            setAllDocApproved(true);
            for (let key in clientDetail.rows) {
                let documentName: string = clientDetail.rows[key].name;
                if (clientDetail.rows[key].path) {
                    clientDetail.rows[key].name = documentName + (clientDetail.rows[key].backPath ? " Front" : "");
                    //  clientDetail.rows[key].size = getFileSize(LOGO_BASE_URL + clientDetail.rows[key].path);
                    let path = clientDetail.rows[key].path.split(".");
                    clientDetail.rows[key].fileType = path[path.length - 1].toUpperCase();
                    clientDetail.rows[key].frontOrBack = "Front";
                    if (
                            clientDetail.rows[key].approvalStatusFront !== DocApprovalStatus.APPROVED.approvalStatus &&
                            clientDetail.rows[key].approvalStatusFront !== DocApprovalStatus.DOCUMENT_REQUESTED.approvalStatus &&
                            clientDetail.rows[key].approvalStatusFront !== DocApprovalStatus.REJECTED.approvalStatus
                    ) {
                        setAllDocApproved(false);
                    }
                    list.push({ ...clientDetail.rows[key], documentName: documentName });
                }
                if (clientDetail.rows[key].backPath) {
                    let path = clientDetail.rows[key].backPath.split(".");
                    clientDetail.rows[key].fileType = path[path.length - 1].toUpperCase();
                    clientDetail.rows[key].frontOrBack = "Back";
                    if (clientDetail.rows[key].approvalStatusBack !== DocApprovalStatus.APPROVED.approvalStatus &&
                            clientDetail.rows[key].approvalStatusBack !== DocApprovalStatus.DOCUMENT_REQUESTED.approvalStatus &&
                            clientDetail.rows[key].approvalStatusBack !== DocApprovalStatus.REJECTED.approvalStatus
                    ) {
                        setAllDocApproved(false);
                    }
                    list.push({
                        ...clientDetail.rows[key],
                        name: documentName + " Back",
                        path: "",
                        documentName: documentName,
                    });
                }
            }
        }
        isGWTGen2 ? setGwtDocumentList(list) : setDocumentList(list);
    };
    const getGWTDocuments = async (userId: string, strategyId?: number) => {
        const isGWTGen2 = (strategyId === GWT_GEN2_STRATEGY);
        if(isGWTGen2){
            return
        }
        const documents = await clientActions.getGWTDocuments(userId);
        let list: any = [];
        if (documents && documents.length > 0) {
            for (let key in documents) {
                console.log(documents[key]);
                let documentName: string = documents[key].document.trim();
                if (documentName === "drivingLicence") {
                    documentName = "Drivers License";
                }
                list.push({
                    ...documents[key],
                    name: documentName,
                    id: key+1,
                    gwtGen1: true,
                    enrollmentId: tempEnrollmentDirectory
                });
            }
        }
        setGwtDocumentList(list);
    };

    const handleRefresh = () => {
        setRefresh(Math.random());
    };

    const handleDocument = async (document: any) => {
        let documentUri: string = "";
        let fileType: string = "";
        let dirName: string = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id;
        if (document.gwtGen1) {
            dirName = tempEnrollmentDirectory;
        }
        if (document.gwtV2) {
            dirName = document.enrollmentId;
        }
        if (document && document.id > 0) {
            let docNameAndType: any = getDocumentNameAndType(document);
            if (docNameAndType.documentUri && docNameAndType.fileType) {
                documentUri = docNameAndType.documentUri;
                let file = documentUri.split(".");
                fileType = file[file.length - 1].toUpperCase();
                const contentType = (fileType == "PDF") ? ("text/pdf") : ("image/*");
                const queryObj = {
                    objectName: documentUri,
                    contentType: contentType,
                };
                if (isGWTGenV2) {
                    Object.assign(queryObj, {gwtRecipient: isGWTGenV2});
                }
                const s3url = await awsActions.getSecureUrl(dirName, queryObj, true);
                setDocumentUrl(s3url);
                setFileType(fileType);
                setOpenDocument(true);
            }
        }
    };

    const dowloadAlldocs = async () => {
        let dirName: string = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id;
        let queryObj = {
            objectName: "notafile",
            contentType: "text/directory",
            isDownloadDir: 1,
        };
        const s3url = await awsActions.getSecureUrlAndDownload(dirName, queryObj);
        console.log("***s3url***", s3url);
        // let blob = new Blob([new Buffer(s3url.Body, "binary")]
        //         , {type: s3url.ContentType});
        // const url = window.URL.createObjectURL(blob);
        // const link = window.document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", documentUri);
        // window.document.body.appendChild(link);
        // link.click();
    };

    const handleClose = () => {
        setOpenDocument(false);
    };

    const handleApproveAll = async () => {
        // let clientId: number = clientDetail && clientDetail.client && clientDetail.client.id || 0;
        // if (clientId < 1) {
        //     return false;
        // }
        await clientActions.approveAllDocsAction({
            clientPolicyId: clientPolicyId,
            docAction: DocApprovalStatus.APPROVED,
        });
        handleRefresh();
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    // TODO NIWC-2640 work in progress
    // 1. button can be same but dialog contents and dropdows will be diffrent
    // upload funxtionality
    const UploadSpecificDocumentButton = (
            <>
                {
                        <Button
                                className="floatRight ml20 mt10"
                                color="primary"
                                label="Upload"
                                onClick={() => {
                                    setUploadCoverLetter(false);
                                    setUploadMoreDocs(true);
                                    setUploadAdditionalTaxDocs(role === 4);
                                }}
                                type="submit"
                                variant="contained"
                        />
                }
            </>
    );

    return (
            <React.Fragment>
                <Grid container spacing={2} justify="space-between">
                    <Grid item xs={12} sm={4}>
                        <TextField
                                value={search}
                                label={"Search"}
                                placeholder={"Search"}
                                variant="outlined"
                                onChange={e => {
                                    setPage(0);
                                    setSearch(e.target.value);
                                }}
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                        className="iconBtn"
                                                        aria-label="search account"
                                                >
                                                    <SearchIcon/>
                                                </IconButton>
                                            </InputAdornment>
                                    ),
                                }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        {
                                (role == 1 || role == 2 || role == 4 || role == 12) && clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id &&
                                UploadSpecificDocumentButton
                        }
                        {(role == 1 || role == 2) && clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id &&
                                <Button
                                        type="submit"
                                        label="Request Docs"
                                        variant="contained"
                                        color="primary"
                                        className="floatRight mt10"
                                        onClick={() => {
                                            setRequestDoc(true);
                                            //setUploadMoreDocs(true)
                                            console.log("Request Docs");
                                        }}
                                />
                        }
                        {/*{( role == 1 || role == 2 ) &&*/}
                        {/*<Link*/}
                        {/*    className="floatLeft"*/}
                        {/*    color="primary"*/}
                        {/*    onClick={() => {*/}
                        {/*        dowloadAlldocs();*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    Download all documents*/}
                        {/*</Link>*/}
                        {/*}*/}

                    </Grid>
                </Grid>
                {
                        (role == 1 || role == 2) && snackBar &&
                        <DocumentApprovalSnackBar allDocApproved={allDocApproved}/>
                }
                {
                        !isGWTGen2 && (role === AccountType.Agent || role === AccountType.Admin || role === AccountType.MasterAdmin) && coverLetterReq &&
                    <CoverLetterSnackBar setUploadMoreDocs={setUploadMoreDocs} setUploadCoverLetter={setUploadCoverLetter} setUploadAdditionalTaxDocs={setUploadAdditionalTaxDocs}/>
                }
                {
                        !isGWTGen2 && (role === AccountType.Agent || role === AccountType.Admin || role === AccountType.MasterAdmin) && additionalTaxDocReq &&
                        <Alert action={
                            <Button
                                    type="button"
                                    variant="contained"
                                    label="Upload Docs"
                                    color="primary"
                                    onClick={() => {
                                        setUploadCoverLetter(false)
                                        setUploadMoreDocs(true);
                                        setUploadAdditionalTaxDocs(true);
                                    }}/>
                        } severity="error" variant="outlined" className={classes.pd10 + " " + classes.mb20 + " " + classes.mt20}>
                            {AdditionalTaxDocsButtonText}
                        </Alert>
                }
                <TableWrap>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHead}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHead}>Doc Type</TableCell>
                            <TableCell align="left" className={classes.tableHead}>File Type</TableCell>
                            <TableCell align="left" className={classes.tableHead}>Date Modified</TableCell>
                            <TableCell align="left" className={classes.tableHead}>Uploaded By</TableCell>
                            <TableCell align="left" style={{ minWidth: "230px" }} className={classes.tableHead}>
                                <span className={"mr15"}>Actions</span>
                                {(role == 1 || role == 2) && !allDocApproved && documentListCount > 0 &&
                                        <Link className="colorBlue" onClick={() => {
                                    setApproveAllDocs(true);
                                }}>Approve All</Link>
                                }
                                </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                                loading &&
                                <img src={LoaderGif} alt="Loading..." style={{
                                    position: "fixed",
                                    left: "0",
                                    right: "0",
                                    top: "30%",
                                    width: "100px",
                                    margin: "0 auto",
                                }}/>

                        }
                        {!loading && documentList && documentList.length > 0 &&
                                documentList.map((document: any) => {
                                    return (
                                            <TableRow key={Math.random()}>
                                                <TableCell component="td" scope="row">
                                                    <a className="colorBlue" onClick={() => {
                                                        handleDocument(document);
                                                    setDocumentToView(document);
                                                    }}>{document.name}</a> {document.name === "Other" && " (" + document.otherDocName + ")"}
                                                </TableCell>
                                                <TableCell component="td" scope="row">
                                                    {document.documentSubType ? document.documentSubType : "N/A"}
                                                </TableCell>
                                                <TableCell component="td" scope="row">
                                                    {document.fileType}
                                                </TableCell>

                                                <TableCell component="td" scope="row">
                                                    {dateUtils.asDbDateFormat(document.updatedAt)}
                                                </TableCell>
                                                <TableCell component="td" scope="row">
                                                    {
                                                            document.user && document.user.firstName + " " + document.user.lastName
                                                    }
                                                </TableCell>
                                                <TableCell align="center">
                                                    {/*<IconButton aria-label="delete" size="small">
                                                        {document.documentType === ClientDocumentType.ADMIN_PROPOSAL ?
                                                                <a target={"_blank"}  href={document.path ? LOGO_BASE_URL + clientDetail.enrollment.id + '/' + document.path : LOGO_BASE_URL + document.backPath } download={document.path ? document.path : document.backPath} > <GetAppOutlinedIcon/> </a>
                                                        :
                                                            (document.documentType === ClientDocumentType.MORE_DOCUMENTS ?
                                                                <a target={"_blank"} href={document.path ? LOGO_BASE_URL + clientDetail.userId + '/' + document.path : LOGO_BASE_URL + document.backPath } download={document.path ? document.path : document.backPath} > <GetAppOutlinedIcon/> </a>
                                                            :
                                                                <a target={"_blank"} href={document.path ? LOGO_BASE_URL + document.path : LOGO_BASE_URL + document.backPath } download={document.path ? document.path : document.backPath} > <GetAppOutlinedIcon/> </a>
                                                            )
                                                        }
                                                    </IconButton>
                                                    { (role == 1 || role == 2) && false &&
                                                    <IconButton aria-label="delete">
                                                        <DeleteOutlineIcon className="colorRed"/>
                                                    </IconButton>
                                                    }*/}
                                                    {
                                                            (role === 1 || role === 2) &&
                                                            <DocumentApprovalActions document={document}
                                                                                     clientDetail={clientDetail}
                                                                                     getClientDocuments={getClientDocuments}
                                                                                     setLoading={setLoading}
                                                                                     setRefresh={setRefresh}
                                                            />
                                                    }

                                                    <Tooltip title="Download"><Link className="colorBlue" onClick={async () => {
                                                        await downloadDocument(document, document.enrollmentId || defaultDirectory, awsActions);
                                                    }}><GetAppOutlinedIcon/></Link></Tooltip>
                                                    {/*{*/}
                                                    {/*        (role === 1 || role === 2) &&*/}
                                                    {/*        ((document.frontOrBack === "Front" && document.approvalStatusFront !== DocApprovalStatus.APPROVED.approvalStatus) ||*/}
                                                    {/*                (document.frontOrBack === "Back" && document.approvalStatusBack !== DocApprovalStatus.APPROVED.approvalStatus))*/}
                                                    {/*        && document.documentType && document.documentType !== ClientDocumentType.ADMIN_PROPOSAL &&*/}
                                                    {/*        <><Tooltip title="Replace">*/}
                                                    {/*            <Link className="colorBlue" onClick={() => {*/}
                                                    {/*                setConfirmDialog(true);*/}
                                                    {/*                setSingleDocDetail(document);*/}
                                                    {/*            }}><PublishOutlinedIcon/></Link>*/}
                                                    {/*        </Tooltip>*/}
                                                    {/*        </>*/}
                                                    {/*}*/}
                                                </TableCell>
                                            </TableRow>
                                    );
                                })
                        }

                        {documentList && documentList.length === 0 &&
                                    <TableRow key={Math.random()}>
                                        <TableCell component="td" colSpan={6}>
                                        <Typography variant="caption" align="left" className="ml15 mt10 ">
                                        There are no
                                            documents
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                        }
                    </TableBody>
                    {!loading && documentList && documentList.length > 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <Pagination className="floatRight" page={Number(page)} rowsPerPage={Number(rowsPerPage)}
                                                    setPage={setPage}
                                                    setRowsPerPage={setRowsPerPage}
                                                    accountList={{ count: documentListCount }}/>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                    }
                </TableWrap>

                <ViewDocument
                        handleNotes={handleDocument}
                        handleClose={handleClose}
                        openDocument={openDocument}
                        documentUrl={documentUrl}
                        fileType={fileType}
                        title={"Documents"}
                        documentToView={documentToView}
                        downloadDocument={(document: any) => downloadDocument(document, document.enrollmentId || defaultDirectory, awsActions, undefined, isGWTGenV2)}
                />
                {
                        uploadMoreDocs &&
                        <UploadSpecificDocument
                                documentList={documentList}
                                tag='document_tabs'
                                clientDetail={clientDetail}
                                coverLetterUploadedFromActionItem={uploadCoverLetter}
                                documentsTab={true}
                                showDocumentFields={role == 4}
                                handleClose={()=>{
                                    setUploadMoreDocs(false);
                                    handleRefresh();
                                    getClientDetail((clientPolicy && clientPolicy.clientId || 0), clientPolicyId, ssnFlag)}
                                }
                                open={uploadMoreDocs} 
                                setCoverLetterReq={setCoverLetterReq}
                                uploadAdditionalTaxDocs={uploadAdditionalTaxDocs}
                                uploadCoverLetter={uploadCoverLetter} 
                        />
                }
                <ConfirmUploadDialog document={singleDocDetail} clientDetail={clientDetail}
                                     confirmDialog={confirmDialog}
                                     setConfirmDialog={setConfirmDialog}
                                     handleRefresh={handleRefresh}/>
                {
                        requestDoc && <RequestClientDocModal
                                user={clientDetail}
                                open={true}
                                content="Request Client Documents"
                                clientDetail={clientDetail}
                                handleClose={() => {
                                    setRequestDoc(false);
                                }}
                        />
                }

                <Dialog
                        fullWidth={true}
                        maxWidth="sm"
                        onClose={() => {

                        }}
                        aria-labelledby="customized-dialog-title"
                        open={approveAllDocs}
                >
                    <DialogContent dividers>
                        <Typography variant="body1" className="mb0">
                            Are you sure you want to approve all docs?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                label="Yes"
                                disabled={!approveAllDocs}
                                onClick={() => {
                                    setApproveAllDocs(false);
                                    setTimeout(() => handleApproveAll(), 800);
                                }}
                        />
                        <Button
                                className="bgRed"
                                size="small"
                                variant="contained"
                                color="primary"
                                label="No"
                                onClick={() => {
                                    setApproveAllDocs(false);
                                }}
                        />
                    </DialogActions>
                </Dialog>

                {
                        <>
                            <Grid container spacing={2} justify="space-between">
                                <Grid item xs={12}>
                                    <Typography variant="body1" component="strong" className="floatLeft w100 mt20">
                                        Great Wealth Transfer Giftor Documents
                                    </Typography>
                                    {
                                            isGWTGen2 && (role === AccountType.MasterAdmin || role === AccountType.Admin) &&
                                            clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.id &&
                                            UploadSpecificDocumentButton
                                    }
                                </Grid>
                            </Grid>
                            {
                                    loading && <CircularLoading />
                            }
                            <TableView {...gridProps} />
                        </>
                }
                <Grid container spacing={2} justify="space-between">
                    <Grid item xs={12}>
                        <Typography variant="body1" component="strong" className="floatLeft w100 mt20">
                            Servicing Documents
                        </Typography>
                        <ServicingDocuments onViewDocument={(doc)=>{
                            handleDocument(doc);
                            setDocumentToView(doc);
                        }} clientDetail={clientDetail}
                                            clientPolicyId={clientPolicyId}/>
                    </Grid>
                </Grid>

                {(role === 1 || role === 2) &&  <><PaymentDocuments />
                    <SupportingDocumentTable onView={(doc)=>{
                        handleDocument(doc);
                        setDocumentToView(doc);
                    }} clientDetail={clientDetail} />
                </>}

            </React.Fragment>
    );
};


let rejectDocument = async ():Promise<any> => { }
const ServicingDocuments = ({ clientDetail, onViewDocument, clientPolicyId }: {
    clientDetail: any,
    onViewDocument: any,
    clientPolicyId: string
}) => {
    const [servicingDocuments, setServicingDocuments] = React.useState<any[]>([])
    const { user: {role} } = useSelector((state: RootState) => state.auth);
    const [currentDoc, setCurrentDoc] = React.useState<any>()
    const { getRequestDocument, approveServicingDoc, updateServiceDocStatus } = useActions(ClientActions);
    const [changingRequest, setChangingRequest] = React.useState(false);
    const fileTypeObject = {
        "EDIT_LEGAL_NAME_CHANGE": {
            label: "Legal Name Change Document",
            requestType: CurrentActionsItems.UPDATE_LEGAL_NAME.actionType
        },
        "EDIT_BENEFICIARY":{
            label: "Edit Beneficiary",
            requestType: CurrentActionsItems.UPDATE_BENEFICIARY.actionType
        },
        "EDIT_PERSONAL_DETAIL": {
            label :"Edit Personal Details",
            requestType: CurrentActionsItems.UPDATE_PERSONAL_DETAIL.actionType
        }
    }

    const updateDocumentStatus = (document) =>{
        return async ()=>{
            const  isFront =  document.frontOrBack == "Front"
            const requestId = document.id;
            const payload = {
                clientId: clientDetail.client.id,
                side: isFront ? "front" : "back",
                documentId: requestId,
                status: "REJECTED",

            }
            return await updateServiceDocStatus(payload)
        }
    }
    const approveDocument = async (document) =>{
        const  isFront =  document.frontOrBack == "Front"
         const requestId = document.id;
        const isRequestedDoc = !!(document.payload)
        console.log(requestId, document)
        const payload = {
            clientId: clientDetail.client.id,
            clientPolicyId: clientPolicyId,
            side: isFront ? "front" : "back",
            documentId: requestId,
            isRequestedDoc
        }
        return await approveServicingDoc(payload)
    }
    const ApproveButton = ({ document }:{ document }) =>{
        
        const documentState = document.frontOrBack == "Front" ? document.approvalStatusFront : document.approvalStatusBack
        let documentStatus = documentState
        // const [documentStatus, setDocumentStatus] = React.useState<'APPROVED' | 'REJECTED' | 'DOCUMENT-REQUESTED' | 'UPLOADED'>(documentState)
        const isRequestedDoc = !!(document.payload)
        // if isRequestedDoc then take 1 as Approved and on 0 REJECTED
        if(isRequestedDoc){
            switch (documentState) {
                case 1:
                    documentStatus = "APPROVED"
                    break;
                case 0:
                    documentStatus = "REJECTED"
                    break;
            }
        }

        switch (documentStatus){
            case "APPROVED":
                return <>
                    <CheckIcon className="textHighLight" />
                    <Link onClick={async ()=>{ }} color={"primary"}  >Approved</Link>
                </>
            case "REJECTED":
                return <>
                    <CloseIcon className="colorRed" />
                    <Link onClick={async ()=>{ }} color={"primary"}  > Rejected </Link>
                </>
            default:
                return <>
                    <Link onClick={async ()=>{
                    const result =await approveDocument(document)
                    if(result){
                        fetchDocs(clientPolicyId)
                    }
                }} color={"primary"}  >Approve</Link>
                    <br/>
                    <Link onClick={async ()=>{
                        // to indicate is it requested doc or not it this will give issue we have set tag from backend to check it si requested doc or not from fetch document api
                        const isRequestedDoc = !!(document.payload)
                        if(isRequestedDoc){
                            rejectDocument = async ():Promise<any> => { }
                        }else{
                            rejectDocument = updateDocumentStatus(document)
                        }
                        setCurrentDoc(document)
                        setChangingRequest(true)
                    }} color={"primary"}  > Reject </Link>
                </>
        }

    }
    
    const gridProps = {
        headers: ["Document", "Doc Type", "File Type", "Date Modified", "Actions"],
        list: servicingDocuments.map((document: any) => {
            return {
                name: (
                        <Link
                                className="backBtn" color="primary"
                                onClick={() => {
                                    onViewDocument && onViewDocument(document);
                                    // setDocumentToView(document);
                                }}
                        > {document.name} </Link>
                ),
                docType: ((fileTypeObject[document.documentType] && fileTypeObject[document.documentType].label) || document.type).replace(/back|front/gi, "").trim(),
                fileTYpe: document.fileType,
                dateModified: dateUtils.asDbDateFormat(document.updatedAt),
                // uploadedBy: document.user && document.user.firstName + " " + document.user.lastName,
                action: ((document.documentType !== "EDIT_BENEFICIARY" && role != 12) ? <ApproveButton document={document} /> : <></>),
            };
        }),
    };
    async function fetchDocs(clientPolicyId: string){
        const addSuffixIfDoesNotExist = (name: string, suffix:string) =>{
            if(typeof name == "string" && !name.includes(suffix)){
                return  name + ` ${suffix}`
            }
            return name
        }
        if(!!clientPolicyId){
            const response = await  getRequestDocument({clientPolicyId: clientPolicyId, withRequestedDocs: role != 4 });
            let list: any[] = [];
            if(response.success){
                for (let key in response.data) {
                    let documentName: string = response.data[key].name;
                    if (response.data[key].path) {
                        response.data[key].name = (response.data[key].backPath ? addSuffixIfDoesNotExist(documentName, "Front") : documentName);
                        let path = response.data[key].path.split(".");
                        response.data[key].fileType = path[path.length - 1].toUpperCase();
                        response.data[key].frontOrBack = "Front";
                        list.push({ ...response.data[key], documentName: documentName, type: response.data[key].name });
                    }
                    if (response.data[key].backPath) {
                        let path = response.data[key].backPath.split(".");
                        response.data[key].fileType = path[path.length - 1].toUpperCase();
                        response.data[key].frontOrBack = "Back";
                        list.push({
                            ...response.data[key],
                            name: addSuffixIfDoesNotExist(documentName, "Back"),
                            path: "",
                            type: response.data[key].name,
                            documentName: documentName,
                        });
                    }
                }
                setServicingDocuments(list)
            }

        }
    }

    React.useEffect(()=>{
        fetchDocs(clientPolicyId)

    },[clientPolicyId])

    return <>
        <TableView {...gridProps} />
        {changingRequest && currentDoc && <RejectChangingRequest
                open={changingRequest}
                setChangingRequest={setChangingRequest}
                requestType={(fileTypeObject[currentDoc.documentType] && fileTypeObject[currentDoc.documentType].requestType) || "DOCUMENT_REJECTED"}
                clientId={clientDetail.client.id}
                clientPolicyId={clientPolicyId}
                createApiPayload={(values) =>{
                   const payload = {...values};
                    const isRequestedDoc = !!(currentDoc.payload)
                    if(isRequestedDoc){
                        payload.callingFrom = "RejectRequestedDoc";
                        payload.documentId = currentDoc.id;
                    }
                  return payload
                }}
                refreshPage={async ()=>{
                    await rejectDocument()
                    await fetchDocs(clientPolicyId)
                }}
        />}
    </>

}
